import { render } from "./WizardLayout.vue?vue&type=template&id=2d165741"
import script from "./WizardLayout.vue?vue&type=script&lang=js"
export * from "./WizardLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__